import { render, staticRenderFns } from "./UserListHeader.vue?vue&type=template&id=5c0f8828&scoped=true"
import script from "./UserListHeader.vue?vue&type=script&lang=ts"
export * from "./UserListHeader.vue?vue&type=script&lang=ts"
import style0 from "./UserListHeader.vue?vue&type=style&index=0&id=5c0f8828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f8828",
  null
  
)

export default component.exports